import React, { useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import Pagination from "./pagination";
import { useDispatch, useSelector } from "react-redux";
import {
  listProduct,
  buildProductListKey,
} from "../../Redux/Actions/ProductActions";
import Loading from "../LoadingError/Loading";
import Message from "../LoadingError/Error";

const ShopSection = (props) => {
  const {
    keyword,
    pagenumber,
    categoryId,
    categoryName,
    categoryDescription,
    departmentId,
    departmentName,
    basePath = "",
    isSearchMode = false,
    isFeaturedMode = false,
    isCategoryMode = false,
    isDepartmentMode = false,
  } = props;

  const dispatch = useDispatch();

  const formatCOP = (value) =>
    new Intl.NumberFormat("es-CO", {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(Number(value));

  const queryKey = useMemo(
    () =>
      buildProductListKey({
        keyword: keyword || "",
        pageNumber: pagenumber || "",
        categoryId: categoryId || "",
        departmentId: departmentId || "",
        featuredOnly: isFeaturedMode,
      }),
    [keyword, pagenumber, categoryId, departmentId, isFeaturedMode]
  );

  const productList = useSelector((state) => state.productList);

  const currentEntry = productList.productsByKey?.[queryKey];
  const loading = productList.loadingByKey?.[queryKey] || false;
  const error = productList.errorByKey?.[queryKey] || null;

  const rawProducts = currentEntry?.products || [];
  const products = rawProducts.filter((product) => Number(product.price) > 0);

  const page = Number(currentEntry?.page || 1);
  const pages = Number(currentEntry?.pages || 1);
  const totalVisibleProducts = rawProducts.length;

  useEffect(() => {
    dispatch(
      listProduct(
        keyword || "",
        pagenumber || "",
        categoryId || "",
        isFeaturedMode,
        departmentId || ""
      )
    );
  }, [
    dispatch,
    keyword,
    pagenumber,
    categoryId,
    departmentId,
    isFeaturedMode,
  ]);

  return (
    <section
      className={`shop-section ${isSearchMode ? "search-results-section" : ""}`}
    >
      <div className="site-shell">
        <div className="site-shell-inner">
          {isSearchMode ? (
            <div className="search-results-header" style={{ marginBottom: 24 }}>
              <h2 style={{ marginBottom: 2, color: "#000000" }}>
                Resultados de la búsqueda
              </h2>

              <p style={{ margin: 0, color: "#000000", fontSize: 18 }}>
                Mostrando {totalVisibleProducts} productos
                {keyword ? ` para "${keyword}"` : ""}
              </p>
            </div>
          ) : isFeaturedMode ? (
            <div className="search-results-header" style={{ marginBottom: 24 }}>
              <h2 style={{ marginBottom: 2, color: "#000000" }}>
                Productos destacados
              </h2>

              <p style={{ margin: 0, color: "#000000" }}>
                Mostrando {totalVisibleProducts} productos en oferta
              </p>
            </div>
          ) : isCategoryMode && categoryId ? (
            <div style={{ marginBottom: 24 }}>
              <h2 style={{ color: "#000000" }}>
                {isDepartmentMode && departmentName
                  ? departmentName
                  : categoryName}
              </h2>

              {categoryDescription && (
                <p style={{ margin: 0, color: "#000000" }}>
                  {categoryDescription}
                </p>
              )}
            </div>
          ) : (
            <h2
              className="categories-name-shop-section"
              style={{ marginBottom: 24, color: "#000000" }}
            >
              Nuestros productos
            </h2>
          )}

          {loading && !currentEntry ? (
            <div className="mb-5">
              <Loading />
            </div>
          ) : error ? (
            <Message variant="alert-danger">{error}</Message>
          ) : (
            <>
              <div className="shop-grid">
                {products.length === 0 ? (
                  <p className="shop-empty-text">
                    {isFeaturedMode
                      ? "No hay productos destacados disponibles."
                      : isSearchMode
                        ? "No se encontraron productos para esta búsqueda."
                        : "No hay productos disponibles."}
                  </p>
                ) : (
                  products.map((product) => (
                    <div className="shop-card" key={product._id}>
                      <div className="border-product">
                        <Link to={`/products/${product._id}`}>
                          <div className="shopBack">
                            {Number(product.discount || 0) > 0 && (
                              <span className="shop-discount-badge">
                                -{product.discount}%
                              </span>
                            )}

                            <img
                              src={product.image}
                              alt={product.name}
                              loading="lazy"
                              decoding="async"
                            />
                          </div>
                        </Link>

                        <div className="shoptext">
                          <p>
                            <Link to={`/products/${product._id}`}>
                              {product.name}
                            </Link>
                          </p>

                          {Number(product.discount || 0) > 0 ? (
                            <div className="shop-price-row">
                              <h3 className="shop-price-discounted">
                                ${formatCOP(product.discountedPrice)}
                              </h3>

                              <span className="shop-price-original">
                                ${formatCOP(product.price)}
                              </span>
                            </div>
                          ) : (
                            <h3>${formatCOP(product.price)}</h3>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>

              <div className="shop-pagination">
                <Pagination
                  pages={pages}
                  page={page}
                  keyword={keyword || ""}
                  basePath={
                    isCategoryMode
                      ? basePath
                      : isFeaturedMode
                        ? "/destacados"
                        : ""
                  }
                />
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default ShopSection;